<template>
  <div>
    <Pie :data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import { Pie } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement
} from "chart.js";

ChartJS.register(Title, Tooltip, Legend, ArcElement);

export default {
  name: "PieChart",
  components: { Pie },
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  computed: {
    chartData() {
      const isEstado = this.data.some(item =>
        ["Activo", "Inactivo", "En mantención", "Disponible", "En reparación", "Otro"].includes(item.label)
      );
      const isUbicacion = this.data.some(item =>
        item.label === "Sin ubicación"
      );

      const coloresPredefinidos = [
        "#42A5F5", "#66BB6A", "#FFA726", "#FF7043",
        "#AB47BC", "#26C6DA", "#EF5350", "#D4E157",
        "#8D6E63", "#5C6BC0", "#26A69A", "#78909C"
      ];

      const colores = this.data.map((item, index) => {
        if (isEstado) {
          switch (item.label) {
            case "Activo":
              return "#4CAF50"; // verde
            case "Disponible":
              return "#2196F3"; // azul
            case "Inactivo":
              return "#9E9E9E"; // gris
            case "En mantención":
            case "En reparación":
              return "#FF9800"; // naranja
            case "Otro":
              return "#78909C"; // blue-grey
            default:
              return coloresPredefinidos[index % coloresPredefinidos.length];
          }
        } else if (isUbicacion) {
          if (item.label === "Sin ubicación") return "#F44336"; // rojo
          return coloresPredefinidos[index % coloresPredefinidos.length];
        } else {
          return coloresPredefinidos[index % coloresPredefinidos.length];
        }
      });

      return {
        labels: this.data.map(d => d.label),
        datasets: [
          {
            data: this.data.map(d => d.valor),
            backgroundColor: colores
          }
        ]
      };
    },
    chartOptions() {
      const isDark = this.$vuetify?.theme?.dark ?? false;
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "bottom",
            labels: {
              color: isDark ? "#e0e0e0" : "#333"
            }
          }
        }
      };
    }
  }
};
</script>

<style scoped>
div {
  height: 300px;
}
</style>
